/**
 * Customer profile → Mailings: every mailing email sent to this customer —
 * campaigns, personalised campaigns and workflows, through all the addresses
 * of the record — with its status, opens and clicks.
 *
 * Reuses the mailing module's table and chips (mailing-page class) so the
 * lines read exactly as they do on the mailing screens.
 */
define('customersDetailBodyMailingsView',[
  'module',
  'underscore',
  'jquery',
  'marionette',
  'mailingShell',
  'entities/mailing'
], function (
  module,
  _,
  $,
  Marionette,
  Shell,
  MailingApi
) {
  'use strict';

  var SOURCE = {
    CAMPAIGN: { label: 'Campaign', route: 'mailing/campaigns/' },
    PERSONALISED: { label: 'Personalised', route: 'mailing/personalised/' },
    WORKFLOW: { label: 'Workflow', route: 'mailing/workflows/' }
  };

  module.exports = Marionette.ItemView.extend({

    className: 'mailing-page customer-detail-mailings-view',

    template: _.template('<div class="mlg-body"><div class="mlg-loading">Loading mailings…</div></div>'),

    ui: {
      body: '.mlg-body'
    },

    onShow: function () {
      var self = this;
      MailingApi.customerHistory(this.model.get('secId')).done(function (history) {
        if (self.isDestroyed) { return; }
        self.render();
        self.renderHistory(history || []);
      }).fail(function (xhr) {
        if (self.isDestroyed) { return; }
        self.ui.body.html('<div class="mlg-error">' + _.escape(MailingApi.errorMessage(xhr)) + '</div>');
      });
    },

    renderHistory: function (history) {
      if (!history.length) {
        this.ui.body.html(Shell.emptyHtml('No mailing was sent to this customer yet.'));
        return;
      }
      var sent = _.filter(history, function (entry) { return entry.status === 'SENT'; });
      var opened = _.filter(sent, function (entry) { return entry.openCount > 0; }).length;
      var clicked = _.filter(sent, function (entry) { return entry.clickCount > 0; }).length;
      var addresses = _.uniq(_.compact(_.pluck(history, 'toEmail')));

      var rows = _.map(history, function (entry) {
        var source = SOURCE[entry.sourceType] || { label: Shell.prettyCase(entry.sourceType || ''), route: null };
        var name = _.escape(entry.sourceName || '—');
        return '<tr>' +
          '<td>' + Shell.formatDate(entry.sentAt, true) + '</td>' +
          '<td><span class="c-sub">' + _.escape(source.label) + '</span><br>' +
            (source.route && entry.sourceSecId ?
              '<a href="#' + source.route + _.escape(entry.sourceSecId) + '">' + name + '</a>' : name) + '</td>' +
          '<td>' + _.escape(entry.subject || '') + '</td>' +
          (addresses.length > 1 ? '<td>' + _.escape(entry.toEmail || '') + '</td>' : '') +
          '<td><span class="mlg-chip st-' + (entry.status || '').toLowerCase() + '">' +
            Shell.prettyCase(entry.status) + '</span>' +
            (entry.errorMessage && entry.status !== 'SENT' ?
              '<div class="c-sub" title="' + _.escape(entry.errorMessage) + '">' + _.escape(entry.errorMessage) + '</div>' : '') +
          '</td>' +
          '<td class="num">' + Shell.formatNumber(entry.openCount) + '</td>' +
          '<td class="num">' + Shell.formatNumber(entry.clickCount) + '</td>' +
          '</tr>';
      }).join('');

      this.ui.body.html(
        '<div class="mlg-hint">' + Shell.formatNumber(sent.length) + ' email(s) sent · ' +
          Shell.formatNumber(opened) + ' opened · ' + Shell.formatNumber(clicked) + ' clicked' +
          (addresses.length > 1 ? ' · ' + addresses.length + ' addresses' : '') + '</div>' +
        '<table class="mlg-table compact">' +
        '<thead><tr><th>Sent</th><th>Mailing</th><th>Subject</th>' +
        (addresses.length > 1 ? '<th>Address</th>' : '') +
        '<th>Status</th><th class="num">Opens</th><th class="num">Clicks</th></tr></thead>' +
        '<tbody>' + rows + '</tbody></table>');
    }
  });
});

